import queryString from "query-string";
import { getHasQuestionsTab, QUESTIONS_TAB_SOURCES } from "analytics/questions_tab";

const PATHNAME_TO_SOURCE_FROM_MAP = {
	"doubletake": "Doubletake",
	"match": "Discovery",
	"who-likes-you": "Likes",
	"who-you-like": "Likes",
	"messages": "Messages",
	"upgrade": "Alist",
	"settings": "Settings",
	"profile": "Profile",
	"flagmod": "Flag mod",
	"home": "Home",
};

export default function sourceFromPathname() {
	const { location: { pathname } } = window;
	const firstPathname = pathname.substr(1).split("/")[0];

	return PATHNAME_TO_SOURCE_FROM_MAP[firstPathname];
}

// ---------------------------------------------------------

const CF_TO_SOURCE = {
	default: "direct",
	discovery: "discovery",
	doubletake: "doubletake",
	messageThread: "message thread",
	matchSearch: "search",
	likesIncoming: "who likes you",
	likesOutgoing: "who you like",
	intros: "intros",
	messagesMutalLikes: "conversations",
};

export const sourceFromCF = () => {
	const cf = queryString.parse(window.location.search).cf;

	if (!cf) {
		return CF_TO_SOURCE.default;
	}

	let res;

	if (cf.includes("intros")) {
		res = CF_TO_SOURCE.intros;
	} else if (cf.includes("quickmatch") || cf.includes("doubletake")) {
		res = CF_TO_SOURCE.doubletake;
	} else if (cf.includes("discovery")) {
		// right now questions tab and disocvery are the same route..
		// so check if it is questions tab
		if (getHasQuestionsTab()) {
			return QUESTIONS_TAB_SOURCES.questions;
		}

		res = CF_TO_SOURCE.discovery;
	} else if (cf.includes("messenger")) {
		res = CF_TO_SOURCE.messageThread;
	} else if (cf.includes("matchsearch")) {
		res = CF_TO_SOURCE.matchSearch;
	} else if (cf.includes("likesIncoming")) {
		res = CF_TO_SOURCE.likesIncoming;
	} else if (cf.includes("likesOutgoing")) {
		res = CF_TO_SOURCE.likesOutgoing;
	} else if (cf.includes("messages-mutuallikes")) {
		res = CF_TO_SOURCE.messagesMutalLikes;
	}

	return res;
};



// WEBPACK FOOTER //
// ./src/analytics/util/source.js